import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-simpler-select'

import NumberInput from  './UI/NumberInput'
import NumberInputNote from  './UI/NumberInputNote'
import Button from  './UI/Button'

import { capitalize, midiNoteFormatter } from '../utilities'
import velocityCurves from '../constants/velocityCurves.json'
import tooltips from '../constants/tooltips.json'

import {
  setGapCaps,
  setGapCapsCurve,
  setGapCapsChannel,
  toggleGapCaps
} from '../actions/'

const BarsGapCapSettings = (props) => {
  const {
    selectedGapCap,
    gapCaps,
    onSetGapCaps,
    onSetGapCapsChannel,
    onGapCapsCurveChange,
    onToggleGapCaps,
    showTooltips
  } = props

  const curves = Object.keys(velocityCurves).map(key => ({value: velocityCurves[key], label: capitalize(key)}))

  const defaultGapCaps = [36, 37, 38, 39, 40, 41]
  const gapCapsDisabled = gapCaps.notes.every(cap => cap === -1)

  return (
    <div className="bars-gap-cap-settings">
      <h4
        data-tip={tooltips['editor-gap-caps']}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
        >Gap Caps <span>{gapCapsDisabled ? '( disabled )' : ''} </span></h4>
      <label
        data-tip={tooltips['editor-gap-caps-selected-input']}
        data-multiline="true"
        data-place="right"
        data-tip-disable={!showTooltips}
        >
        <span className="gap-cap-name">Selected Cap { selectedGapCap + 1 > 0 && selectedGapCap + 1 }</span>
        <NumberInputNote
          name='gap-cap'
          placeholder="select"
          min={-1} max={127}
          step={1}
          controls={false}
          disabled={selectedGapCap === -1 ? true : false}
          value={gapCaps.notes[selectedGapCap]}
          onChange={note => {
            onSetGapCaps(gapCaps.notes, selectedGapCap, note)
          }}
        />
      </label>
      <label
        className='gap-curves-label'
        data-tip={tooltips['editor-gap-caps-curve']}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
        >
        Curve*
        <Select
          name="gap-cap-curves"
          value={gapCaps.curve}
          options={curves}
          onChange={onGapCapsCurveChange}
        />
      </label>
      <label
        data-tip={tooltips['editor-gap-caps-channel']}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
        >
        Channel*
        <NumberInput
          min={1}
          max={16}
          value={ gapCaps.channel + 1 }
          onChange={onSetGapCapsChannel}
        />
      </label>
      <Button
        name={gapCapsDisabled ? 'Enable All' :  'Disable All' }
        onClick={() => onToggleGapCaps(gapCapsDisabled ? defaultGapCaps : null)}
        data-tip={tooltips['editor-gap-caps-toggle']}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    gapCaps: state.currentPreset.gapCaps,
    selectedGapCap: state.editor.selectedGapCap,
    showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onGapCapsCurveChange: (value) => {
      dispatch(setGapCapsCurve(~~value))
    },
    onSetGapCapsChannel: (value) => {
      dispatch(setGapCapsChannel(~~value - 1))
    },
    onSetGapCaps: (notes, index, note) => {
      dispatch(setGapCaps(notes, index, note))
    },
    onToggleGapCaps: (defaultCaps) => {
      dispatch(toggleGapCaps(defaultCaps))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BarsGapCapSettings)
